// @ts-ignore
import {post, request} from '@/utils/request.js'

//首页媒体、客服、用户信息接口
export const getHomePage = () =>request('/api/index/index')
export const getHomePageTel = () =>request('/api/index/tel')

//首页顶部内外盘分类
export const getTopCate = () =>request(`/api/index/topcate`)

//首页产品账户类型  id:1免费 2付费
export const getAccountType = (id,c) =>request(`/api/index/productcate?t=${id}&c=${c}`)

//首页产品账户资金列表
export const getAccountFundsList = (id) =>request(`/api/index/productpricecate?t=${id}`)

//首页产品信息接口
export const getProductDetail = (id) =>request(`/api/index/productinfo?id=${id}`)

//首页产品描述信息接口
export const getProductDesc = (id='') =>request(`/api/index/productkey?t=${id}`)

//首页获取轮播图
export const getBanner = (id='') =>request(`/api/index/banner`)

//下载
export const getDownLink = () =>request(`/api/index/down`)

//获取站内信列表
export const getMessageList = ({start=0,count=10})=> request('/api/user/message',{params:{start,count}})
// 获取站内信详情
export const getMessageInfo =({id='', cate=''})=> request(`/api/user/messageinfo`,{params:{id,cate}});
//获取全部已读
export const getMessageAllStatus = ()=> request('/api/user/messageallread');
//获取站内信全部数据状态
export const getMessageStatus = ()=> request('/api/user/messagestatus');

// 获取积分活动
export const getPointActivity = () =>request('/api/activity/point')
//积分活动领取
export const savePointActivity = data => request('/api/activity/pointget',{...post,data});